import React, { useState } from "react";
import { Collapse } from "antd";
import ContentCard from "../../ui/ContentCard";
import { FaChevronDown } from "react-icons/fa6";
import styles from "../../styles/Components/pricing-plan/PricingFaq.module.css";
import { faqData } from "./PricingFaqData";

const { Panel } = Collapse;

export default function PricingFaq() {
  const [activeTab, setActiveTab] = useState("general");

  const changeTab = (key) => () => setActiveTab(key);

  return (
    <ContentCard className={styles.container}>
      <h4 className={styles.title}>Q&A</h4>
      <ul className={styles.tabs}>
        <li
          className={`${styles.tab} ${activeTab === "general" ? styles.activeTab : ""}`}
          onClick={changeTab("general")}
        >
          General
        </li>
        <li
          className={`${styles.tab} ${activeTab === "basic" ? styles.activeTab : ""}`}
          onClick={changeTab("basic")}
        >
          Basic Features
        </li>
        <li
          className={`${styles.tab} ${activeTab === "bot" ? styles.activeTab : ""}`}
          onClick={changeTab("bot")}
        >
          AI Bot
        </li>
        <li
          className={`${styles.tab} ${activeTab === "signals" ? styles.activeTab : ""}`}
          onClick={changeTab("signals")}
        >
          AI Signals
        </li>
        <li
          className={`${styles.tab} ${activeTab === "advanced" ? styles.activeTab : ""}`}
          onClick={changeTab("advanced")}
        >
          Advanced Features
        </li>
      </ul>
      <Collapse
        accordion
        bordered={false}
        expandIcon={({ isActive }) => (
          <FaChevronDown
            rotate={isActive ? 90 : 0}
            style={{ transform: `rotate(${isActive ? "-90deg" : 0})` }}
          />
        )}
        expandIconPosition="end"
        className={styles.collapseContainer}
      >
        {faqData?.[activeTab].map((item, index) => (
          <Panel
            header={<strong>{item.question}</strong>}
            key={index}
            style={{
              background: "#fff",
            }}
          >
            <p
              className={styles.answer}
              style={{ margin: 0, lineHeight: 1.6, color: "#555" }}
            >
              {item.answer}
            </p>
          </Panel>
        ))}
      </Collapse>
    </ContentCard>
  );
}
